import React, { FunctionComponent, useEffect } from 'react';
import styled from 'styled-components';
import { T } from 'src/shared/helpers';
import { useDialogManager } from '../dialog';
import QuickSearchDialog from '../quickSearch/quickSearchDialog';

// Sidebar-specific quick search: fits the narrow sidebar width and shares
// the same QuickSearchDialog as the topbar version. Registers the Ctrl+K
// shortcut globally while the sidebar is mounted.

const Wrap = styled.div`
    padding: 10px 12px;
`;

const InputWrap = styled.div`
    position: relative;
`;

const Input = styled.input`
    width: 100%;
    padding: 7px 12px;
    padding-right: 58px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    font-size: 12px;
    font-family: inherit;
    color: #333;
    background: rgba(0, 0, 0, 0.02);
    box-sizing: border-box;
    cursor: pointer;
    transition:
        border-color 0.15s ease,
        background 0.15s ease;

    &::placeholder {
        color: #999;
    }

    &:focus,
    &:hover {
        border-color: rgba(0, 0, 0, 0.25);
        background: white;
        outline: none;
    }
`;

const Kbd = styled.span`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 9px;
    font-weight: 600;
    color: #888;
    background: rgba(0, 0, 0, 0.06);
    padding: 2px 6px;
    border-radius: 4px;
    pointer-events: none;
    letter-spacing: 0.3px;
`;

const SidebarQuickSearch: FunctionComponent = () => {
    const { showDialog } = useDialogManager();

    const openSearch = () => {
        showDialog('quick-search', <QuickSearchDialog />);
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key === 'k') {
                e.preventDefault();
                e.stopImmediatePropagation();
                openSearch();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Wrap>
            <InputWrap>
                <Input placeholder={T._('Quick search...', 'Admin')} onFocus={openSearch} onClick={openSearch} />
                <Kbd>CTRL+K</Kbd>
            </InputWrap>
        </Wrap>
    );
};

export default SidebarQuickSearch;
